import React from "react";
import { ButtonWrapper } from "./style";

interface InputProps {
  label: string;
  theme?: "primary" | "secondary" | "alternate";
  type?: "submit" | "button";
  width?: string;
  fontSize?: string;
  height?: string;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}
export const Button = ({
  label,
  type = "button",
  theme = "primary",
  width = "100%",
  fontSize = "16px",
  height = "56px",
  onClick,
  disabled = false,
}: InputProps) => {
  return (
    <ButtonWrapper
      $theme={theme}
      $width={width}
      type={type}
      onClick={onClick}
      $fontSize={fontSize}
      $height={height}
      disabled={disabled}
    >
      {label}
    </ButtonWrapper>
  );
};
